import get from 'lodash/get';
import { isLandingRetentionSelector, isSemUrlSelector } from '~/Serp/selectors';

export const PAGEVIEW_HOME_VERTICAL = 2;
export const PAGEVIEW_SERP = 5;
export const PAGEVIEW_ADPAGE_RPM_FORM = 8;
export const PAGEVIEW_ADPAGE_RPM_TRAFFIC = 9;
export const PAGEVIEW_ERROR_404 = 13;
export const PAGEVIEW_NO_RESULTS = 14;
export const PAGEVIEW_KEYWORDS_404 = 16;
export const PAGEVIEW_ERROR_500 = 17;
export const PAGEVIEW_BROWSE = 18;
export const PAGEVIEW_LANDING = 23;
export const PAGEVIEW_LOCATION_PAGE = 28;
export const PAGEVIEW_ALERT_LANDING = 37;
export const PAGEVIEW_NOTIFICATIONS_MANAGER = 36;
export const PAGEVIEW_CAPTURE_FEEDBACK = 40;

export const computePageviewTypeFromState = state => {
  const trovit = state.trovit;
  const statusCode = get(trovit, ['query', 'statusCode']);
  const pageName = get(trovit, ['query', 'pageName']);
  const isLandingRetention = isLandingRetentionSelector(state);
  const isSem = isSemUrlSelector(state);

  if (statusCode) {
    return statusCode === 500 ? PAGEVIEW_ERROR_500 : PAGEVIEW_ERROR_404;
  }

  switch (pageName) {
    case 'index':
    case 'indexJobs':
    case 'indexCars':
    case 'indexProducts':
      return PAGEVIEW_HOME_VERTICAL;

    case 'serp': {
      if (isSem) {
        return PAGEVIEW_LANDING;
      }

      if (isLandingRetention) {
        return PAGEVIEW_ALERT_LANDING;
      }

      return PAGEVIEW_SERP;
    }

    case 'notificationsManagerEmail/notificationsManagerEmail':
      return PAGEVIEW_NOTIFICATIONS_MANAGER;

    case 'notificationsManagerWebPush':
      return PAGEVIEW_NOTIFICATIONS_MANAGER;

    case 'captureFeedback':
      return PAGEVIEW_CAPTURE_FEEDBACK;

    case 'location':
      return PAGEVIEW_LOCATION_PAGE;

    case 'notfound':
      return PAGEVIEW_ERROR_404;

    case 'browse':
      return PAGEVIEW_BROWSE;

    case 'apage': {
      const hasForm = get(state, ['adPage', 'ad', 'attributes', 'source', 'ad', 'has_adpage_form']);
      return hasForm ? PAGEVIEW_ADPAGE_RPM_FORM : PAGEVIEW_ADPAGE_RPM_TRAFFIC;
    }

    default:
      return null;
  }
};



// WEBPACK FOOTER //
// ./app/utils/pageviewTypes.js